module.exports = __webpack_public_path__ + "static/img/pn.90f828d4.svg";